<template>
  <div>
    <Row :gutter="20" type="flex" class="grid-list-row mx-0">
      <Col
        :span="column.colSpan"
        align="middle"
        v-for="(column, index) in sectionHeader"
        :key="index"
      >
        <span v-if="getOrderDetails[column.label]">
          <span v-if="column.label === 'order_no'">
            <p>
              <span>{{ getColumnValue(column) }}</span>
              <small v-if="getOrderDetails.created_at">
                {{ getOrderDetails.created_at }}
              </small>
            </p>
          </span>
          <span v-else-if="column.label === 'vehicle_type'">
            <p>
              <span>{{ getColumnValue(column) }}</span>
              <small v-if="getOrderDetails.vehicle_req_date">
                {{ getOrderDetails.vehicle_req_date }}
              </small>
            </p>
          </span>
          <span class="status status-icon-bottom status-teal"
            v-else-if="column.label === 'status'">
            {{$t($statusUtil.getMainStatusObj(getOrderDetails[column.label]).tlabel)}}
          </span>
          <span v-else-if="column.tooltip">
            <Tooltip
              effect="dark"
              placement="bottom"
              v-if="getOrderDetails[column.label] && getOrderDetails[column.label].tooltipText"
            >
              <div slot="content">
                {{ getOrderDetails[column.label].tooltipText }}
              </div>
              <span>{{ getOrderDetails[column.label].value }}</span>
            </Tooltip>
            <span v-else>{{ getOrderDetails[column.label].value }}</span>
          </span>
          <span v-else>{{ getOrderDetails[column.label] }}</span>
        </span>
        <span v-else> - </span>
      </Col>
      <Col align="middle" class="col-push text-right">
        <span
          v-if="$hasPermission('accept_indent_requests') && !getOrderDetails.is_accepted"
          class="link-action"
          @click="$emit('showActions')">
          <svgicon name="accept" width="10" height="10" />
          <span v-if="isFilterClosed">{{$t('INDENT_ACCEPT')}}</span>
        </span>
        <span
          class="text-green1"
          v-else-if="$hasPermission('accept_indent_requests') && getOrderDetails.is_accepted">
          <svgicon name="icon-time" width="10" height="10" />
          <span>{{$t('WAITING_FOR_SHIPPER_APPROVAL')}}</span>
        </span>
      </Col>
    </Row>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import getRoute from '@/lib/Route';
import moment from 'moment';

export default {
  props: {
    order: {
      type: Object,
      default: () => ({}),
    },
    sectionHeader: {
      type: Array,
      default: () => ([]),
    },
    isFilterClosed: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {};
  },
  methods: {
    getMainStatusId(id) {
      let mainStatusId = this.$statusUtil.getMainStatusId(id);
      if (!this.$hasFeature('transporter_delivery_pending_status')
        && mainStatusId === this.$statusUtil.getStatusId('delivery_pending')) {
        mainStatusId = this.$statusUtil.getStatusId('delivered');
      }
      return mainStatusId;
    },
    getColumnValue(column) {
      return this.getOrderDetails[column.tlabel] || this.getOrderDetails[column.label];
    },
  },
  computed: {
    ...mapGetters({
      clientConfigurations: 'app/currentClientConfig',
    }),
    timeFormat() {
      return (this.clientConfigurations && this.clientConfigurations.is_datepicker_24H_enabled) ? 'DD-MM-yyyy HH:mm' : 'DD-MM-yyyy hh:mm A';
    },
    getOrderDetails() {
      const orderDetails = {
        order_no: this.order.order_no,
        created_at: this.order.created_at ? moment(this.order.created_at).format('DD MMM YYYY') : null,
        route: getRoute(this.order.sources, this.order.destinations),
        vehicle_type: this.order.vehicle_type && this.order.vehicle_type.short_form,
        expires_at: (this.order.rfqData && this.order.rfqData.expires_at) ?
          moment(this.order.rfqData.expires_at).format('DD MMM YYYY | hh:mm A') : null,
        vehicle_req_date: (this.order.sources && this.order.sources.length) ? (() => {
          const maxDate = this.order.sources.reduce((a, b) => (a.vehicle_req_date >
            b.vehicle_req_date ? a : b)).vehicle_req_date;
          return maxDate ? moment(maxDate).format(this.timeFormat) : null;
        })() : null,
        status: this.getMainStatusId(this.order.status),
        is_accepted: this.order.is_accepted,
      };
      return orderDetails;
    },
  },
};
</script>
